import { render } from "./BaseThedialog.vue?vue&type=template&id=7a9cc893&scoped=true"
import script from "./BaseThedialog.vue?vue&type=script&lang=js"
export * from "./BaseThedialog.vue?vue&type=script&lang=js"

import "./BaseThedialog.vue?vue&type=style&index=0&id=7a9cc893&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9cc893"]])

export default __exports__